import Step from '../_Step'
import {setup, createField, collectValues, validate, validateSilent} from './quickfield-base-methods'

class LookAndFeel extends Step
	constructor: ()->
		super()
		@fields = []
	
	render: ()->
		super([])
	
	onNextStep: ()->
		fbq?('trackCustom', 'FilledLookAndFeel')
	
	componentDidMount: ()-> @setup()
	setup: setup
	createField: createField
	collectValues: collectValues
	validate: validate
	validateSilent: validateSilent


export default LookAndFeel